import { callApi } from "@/api/api-core";

export const getContent = function(
    identifier,
    languageCode,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v2/content/get",
        {
            identifier,
            languageCode
        },
        ownerHandlesFailure
    );
};
